/**
 * AA-safe warning tone — the MUI warning-Alert color pair (strategy-blocks
 * designer invariant #8). Raw `warning.main` (#ED6C02) on white measures
 * 3.11:1 and fails AA for text; `warning.50` is not a MUI palette key at all.
 * These mirror MUI Alert's standardWarning derivation and stay theme-aware.
 */
import { darken, lighten, type Theme } from '@mui/material/styles';

/** Text/icon color: light «#663C00»-class, dark a pale amber — both ≥4.5:1. */
export const warningToneText = (theme: Theme): string =>
  theme.palette.mode === 'dark'
    ? lighten(theme.palette.warning.light, 0.6)
    : darken(theme.palette.warning.light, 0.6);

/** Fill color: light «#FFF4E5»-class, dark a deep amber wash. */
export const warningToneBg = (theme: Theme): string =>
  theme.palette.mode === 'dark'
    ? darken(theme.palette.warning.light, 0.85)
    : lighten(theme.palette.warning.light, 0.9);
